import { gql, useQuery } from '@apollo/client';

import type { GetServicedDeals } from './__generated__/getServicedDeals_gql';
export const GET_SERVICED_DEALS = gql`
  query GetServicedDeals {
    getServicedDeals {
      id
      role
      listing {
        id
        name
      }
      counterparty {
        __typename
        ... on PrivateCompany {
          id
          name
        }
        ... on UserCompany {
          id
          name
        }
      }
    }
  }
`;

export function useServicedDeals() {
  return useQuery<GetServicedDeals>(GET_SERVICED_DEALS);
}
